import React from 'react'

export default function Plan() {
  return (
    <div>plan</div>
  )
}